import {faCircleNodes} from "@fortawesome/free-solid-svg-icons";

export default faCircleNodes;
